import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=ffe49a42&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=ffe49a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe49a42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffe49a42')) {
      api.createRecord('ffe49a42', component.options)
    } else {
      api.reload('ffe49a42', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=ffe49a42&scoped=true&", function () {
      api.rerender('ffe49a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24Y8rfSZK1KVJ/JS/teamMember.vue"
export default component.exports